const EXCLUSION_STATUS = {
  INCLUDED: {
    label: 'Included',
    value: 'INCLUDED',
  },
  EXCLUDED: {
    label: 'Excluded',
    value: 'EXCLUDED',
  },
}

module.exports = EXCLUSION_STATUS
